// extracted by mini-css-extract-plugin
export default {"blue-text":"style__blue-text--cstKq","blueText":"style__blue-text--cstKq"};